export default __webpack_public_path__ + "static/media/defaultUserPhoto.853c5826.svg";